export default __webpack_public_path__ + "static/media/gallery-wip-emitter_06.e64d5349.jpg";